


const ListOfQuotes = [
    {
        _id: "5fac7537146f33d894d61ec1",
        quote: "Spread love everywhere you go. Let no one ever come to you without leaving happier.",
        arthur: "Mother Teresa",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ec2",
        quote: "When you reach the end of your rope, tie a knot in it and hang on.",
        arthur: "Franklin D. Roosevelt",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ec3",
        quote: "Always remember that you are absolutely unique. Just like everyone else.",
        arthur: "Margaret Mead",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ec4",
        quote: "Don't judge each day by the harvest you reap but by the seeds that you plant.",
        arthur: "Robert Louis Stevenson",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ec5",
        quote: "The future belongs to those who believe in the beauty of their dreams.",
        arthur: "Eleanor Roosevelt",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ec6",
        quote: "Tell me and I forget. Teach me and I remember. Involve me and I learn.",
        arthur: "Benjamin Franklin",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ec7",
        quote: "The best and most beautiful things in the world cannot be seen or even touched - they must be felt with the heart.",
        arthur: "Helen Keller",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ec9",
        quote: "Whoever is happy will make others happy too.",
        arthur: "Anne Frank",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ec8",
        quote: "It is during our darkest moments that we must focus to see the light.",
        arthur: "Aristotle",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61eca",
        quote: "Do not go where the path may lead, go instead where there is no path and leave a trail.",
        arthur: "Ralph Waldo Emerson",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ecb",
        quote: "If life were predictable it would cease to be life and be without flavor.",
        arthur: "Eleanor Roosevelt",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ecc",
        quote: "In the end, it's not the years in your life that count. It's the life in your years.",
        arthur: "Abraham Lincoln",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ecd",
        quote: "Life is a succession of lessons which must be lived to be understood.",
        arthur: "Ralph Waldo Emerson",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ece",
        quote: "You will face many defeats in life, but never let yourself be defeated.",
        arthur: "Maya Angelou",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ecf",
        quote: "Never let the fear of striking out keep you from playing the game.",
        arthur: "Babe Ruth",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ed0",
        quote: "Life is never fair, and perhaps it is a good thing for most of us that it is not.",
        arthur: "Oscar Wilde",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ed1",
        quote: "The only impossible journey is the one you never begin.",
        arthur: "Tony Robbins",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ed2",
        quote: "In this life we cannot do great things. We can only do small things with great love.",
        arthur: "Mother Teresa",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ed3",
        quote: "Only a life lived for others is a life worthwhile.",
        arthur: "Albert Einstein",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ed4",
        quote: "The purpose of our lives is to be happy.",
        arthur: "Dalai Lama",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ed5",
        quote: "Life is what happens when you're busy making other plans.",
        arthur: "John Lennon",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ed6",
        quote: "You only live once, but if you do it right, once is enough.",
        arthur: "Mae West",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ed7",
        quote: "Live in the sunshine, swim the sea, drink the wild air.",
        arthur: "Ralph Waldo Emerson",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ed8",
        quote: "Go confidently in the direction of your dreams! Live the life you've imagined.",
        arthur: "Henry David Thoreau",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ed9",
        quote: "The greatest glory in living lies not in never falling, but in rising every time we fall.",
        arthur: "Nelson Mandela",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61eda",
        quote: "Life is really simple, but we insist on making it complicated.",
        arthur: "Confucius",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61edb",
        quote: "May you live all the days of your life.",
        arthur: "Jonathan Swift",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61edd",
        quote: "Do not let making a living prevent you from making a life.",
        arthur: "John Wooden",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61edc",
        quote: "Life itself is the most wonderful fairy tale.",
        arthur: "Hans Christian Andersen",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ede",
        quote: "Life is ours to be spent, not to be saved.",
        arthur: "D. H. Lawrence",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61edf",
        quote: "Keep smiling, because life is a beautiful thing and there's so much to smile about.",
        arthur: "Marilyn Monroe",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ee0",
        quote: "Life is a long lesson in humility.",
        arthur: "-James M. Barrie",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ee1",
        quote: "In three words I can sum up everything I've learned about life: it goes on.",
        arthur: "Robert Frost",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ee2",
        quote: "Love the life you live. Live the life you love.",
        arthur: "Bob Marley",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ee3",
        quote: "Life is either a daring adventure or nothing at all.",
        arthur: "Helen Keller",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ee4",
        quote: "You have brains in your head. You have feet in your shoes. You can steer yourself any direction you choose.",
        arthur: "Dr. Seuss",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ee5",
        quote: "Life is made of ever so many partings welded together.",
        arthur: "Charles Dickens",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ee7",
        quote: "Life is trying things to see if they work.",
        arthur: "Ray Bradbury",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ee6",
        quote: "Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma -- which is living with the results of other people's thinking.",
        arthur: "Steve Jobs",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ee8",
        quote: "Many of life's failures are people who did not realize how close they were to success when they gave up.",
        arthur: "Thomas A. Edison",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ee9",
        quote: "The secret of success is to do the common thing uncommonly well.",
        arthur: "John D. Rockefeller Jr.",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61eeb",
        quote: "Success is not final; failure is not fatal: It is the courage to continue that counts.",
        arthur: "Winston S. Churchill",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61eea",
        quote: "I find that the harder I work, the more luck I seem to have.",
        arthur: "Thomas Jefferson",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61eec",
        quote: "The way to get started is to quit talking and begin doing.",
        arthur: "Walt Disney",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61eed",
        quote: "Don't be distracted by criticism. Remember -- the only taste of success some people get is to take a bite out of you.",
        arthur: "Zig Ziglar",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61eee",
        quote: "Success usually comes to those who are too busy to be looking for it.",
        arthur: "Henry David Thoreau",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61eef",
        quote: "I never dreamed about success, I worked for it.",
        arthur: "Estee Lauder",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ef0",
        quote: "Success seems to be connected with action. Successful people keep moving. They make mistakes but they don't quit.",
        arthur: "Conrad Hilton",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ef2",
        quote: "The real test is not whether you avoid this failure, because you won't. It's whether you let it harden or shame you into inaction, or whether you learn from it; whether you choose to persevere.",
        arthur: "Barack Obama",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ef1",
        quote: "There are no secrets to success. It is the result of preparation, hard work, and learning from failure.",
        arthur: "Colin Powell",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ef3",
        quote: "The only limit to our realization of tomorrow will be our doubts of today.",
        arthur: "Franklin D. Roosevelt",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ef4",
        quote: "It is better to fail in originality than to succeed in imitation.",
        arthur: "Herman Melville",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ef6",
        quote: "The road to success and the road to failure are almost exactly the same.",
        arthur: "Colin R. Davis",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ef5",
        quote: "Successful people do what unsuccessful people are not willing to do. Don't wish it were easier; wish you were better.",
        arthur: "Jim Rohn",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ef7",
        quote: "I failed my way to success.",
        arthur: "Thomas Edison",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ef8",
        quote: "If you set your goals ridiculously high and it's a failure, you will fail above everyone else's success.",
        arthur: "James Cameron",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61ef9",
        quote: "If you really look closely, most overnight successes took a long time.",
        arthur: "Steve Jobs",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61efa",
        quote: "A successful man is one who can lay a firm foundation with the bricks others have thrown at him.",
        arthur: "David Brinkley",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61efc",
        quote: "Try not to become a man of success. Rather become a man of value.",
        arthur: "Albert Einstein",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61efb",
        quote: "Things work out best for those who make the best of how things work out.",
        arthur: "John Wooden",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61efd",
        quote: "Don't be afraid to give up the good to go for the great.",
        arthur: "John D. Rockefeller",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61efe",
        quote: "Always bear in mind that your own resolution to success is more important than any other one thing.",
        arthur: "Abraham Lincoln",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61eff",
        quote: "Success is walking from failure to failure with no loss of enthusiasm.",
        arthur: "Winston Churchill",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f01",
        quote: "If you want to achieve excellence, you can get there today. As of this second, quit doing less-than-excellent work.",
        arthur: "Thomas J. Watson",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f00",
        quote: "You know you are on the road to success if you would do your job and not be paid for it.",
        arthur: "Oprah Winfrey",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f02",
        quote: "If you genuinely want something, don't wait for it -- teach yourself to be impatient.",
        arthur: "Gurbaksh Chahal",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f03",
        quote: "The only place where success comes before work is in the dictionary.",
        arthur: "Vidal Sassoon",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f04",
        quote: "If you are not willing to risk the usual, you will have to settle for the ordinary.",
        arthur: "Jim Rohn",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f06",
        quote: "People who succeed have momentum. The more they succeed, the more they want to succeed and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.",
        arthur: "Tony Robbins",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f05",
        quote: "Before anything else, preparation is the key to success.",
        arthur: "Alexander Graham Bell",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f07",
        quote: "Believe you can and you're halfway there.",
        arthur: "Theodore Roosevelt",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f08",
        quote: "The only person you are destined to become is the person you decide to be.",
        arthur: "Ralph Waldo Emerson",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f09",
        quote: "I've learned that people will forget what you said, people will forget what you did, but people will never forget how you made them feel.",
        arthur: "Maya Angelou",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f0a",
        quote: "The question isn't who is going to let me; it's who is going to stop me.",
        arthur: "Ayn Rand",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f0b",
        quote: "Winning isn't everything, but wanting to win is.",
        arthur: "Vince Lombardi",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f0c",
        quote: "Whether you think you can or you think you can't, you're right.",
        arthur: "Henry Ford",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f0d",
        quote: "You miss 100% of the shots you don't take.",
        arthur: "Wayne Gretzky",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f0f",
        quote: "You become what you believe.",
        arthur: "Oprah Winfrey",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f10",
        quote: "The most difficult thing is the decision to act, the rest is merely tenacity.",
        arthur: "Amelia Earhart",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f0e",
        quote: "I alone cannot change the world, but I can cast a stone across the water to create many ripples.",
        arthur: "Mother Teresa",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f11",
        quote: "How wonderful it is that nobody need wait a single moment before starting to improve the world.",
        arthur: "Anne Frank",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f13",
        quote: "Everything you've ever wanted is on the other side of fear.",
        arthur: "George Addair",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f12",
        quote: "An unexamined life is not worth living.",
        arthur: "Socrates",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f14",
        quote: "Dream big and dare to fail.",
        arthur: "Norman Vaughan",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f15",
        quote: "You may be disappointed if you fail, but you are doomed if you don't try.",
        arthur: "Beverly Sills",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f16",
        quote: "Life is 10% what happens to me and 90% of how I react to it.",
        arthur: "Charles Swindoll",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f17",
        quote: "Nothing is impossible, the word itself says, ‘I'm possible!'",
        arthur: "Audrey Hepburn",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f18",
        quote: "It does not matter how slowly you go as long as you do not stop.",
        arthur: "Confucius",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f19",
        quote: "When everything seems to be going against you, remember that the airplane takes off against the wind, not with it.",
        arthur: "Henry Ford",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f1a",
        quote: "Too many of us are not living our dreams because we are living our fears.",
        arthur: "Les Brown",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f1b",
        quote: "I have learned over the years that when one's mind is made up, this diminishes fear.",
        arthur: "Rosa Parks",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f1c",
        quote: "I didn't fail the test. I just found 100 ways to do it wrong.",
        arthur: "Benjamin Franklin",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f1d",
        quote: "If you're offered a seat on a rocket ship, don't ask what seat! Just get on.",
        arthur: "Sheryl Sandberg",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f1e",
        quote: "I attribute my success to this: I never gave or took any excuse.",
        arthur: "Florence Nightingale",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f1f",
        quote: "I would rather die of passion than of boredom.",
        arthur: "Vincent van Gogh",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f20",
        quote: "If you look at what you have in life, you'll always have more. If you look at what you don't have in life, you'll never have enough.",
        arthur: "Oprah Winfrey",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f21",
        quote: "Dreaming, after all, is a form of planning.",
        arthur: "Gloria Steinem",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f22",
        quote: "Whatever the mind of man can conceive and believe, it can achieve.",
        arthur: "Napoleon Hill",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f24",
        quote: "Twenty years from now you will be more disappointed by the things that you didn't do than by the ones you did do. So, throw off the bowlines, sail away from safe harbor, catch the trade winds in your sails. Explore, Dream, Discover.",
        arthur: "Mark Twain",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    },
    {
        _id: "5fac7537146f33d894d61f23",
        quote: "First, have a definite, clear practical ideal; a goal, an objective. Second, have the necessary means to achieve your ends; wisdom, money, materials, and methods. Third, adjust all your means to that end.",
        arthur: "Aristotle",
        date: "Wed Nov 11 2020 15:35:18 GMT-0800 (Pacific Standard Time)"
    }
]

export default ListOfQuotes;